'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm from "./app.data.-App-Document-Data-Form.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$() {
}
export { $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ as $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ };
$p = $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$() {
}
export { $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ as $h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ };
$h_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$.prototype = $p;
$p.n = (function() {
  return "CertificateOfOrigin";
});
$p.bKi = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dForm.$c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKi(p);
});
var $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$, "app.data.AppDocumentDataForm$CertificateOfOrigin$", ({
  B5: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ as $d_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ };
var $n_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$;
function $m_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$() {
  if ((!$n_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$)) {
    $n_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ = new $c_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$();
  }
  return $n_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$;
}
export { $m_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ as $m_Lapp_data_AppDocumentDataForm$CertificateOfOrigin$ };
//# sourceMappingURL=app.data.-App-Document-Data-Form$-Certificate-Of-Origin$.js.map
